import { useStore } from '@/store/useStore';

export type GameWindowDataScope = {
  region: string;
  product: string;
  platform: 'web' | 'android';
};

/**
 * Region/product/platform the service resolves a game against. Sending `state`
 * instead is silently ignored and the region falls back to MI.
 */
export const getGameWindowDataScope = (): GameWindowDataScope => {
  const { region, product, glsPlatform } = useStore.getState().runtime;

  const platform = glsPlatform === 'ANDROID_APP' ? 'android' : 'web';

  return {
    region: region ?? '',
    product: (product ?? 'casino').toLowerCase(),
    platform,
  };
};

export default getGameWindowDataScope;
